import { ISearchContext } from "../../global/models/search-context";

const filterRegex = /[a-zA-z]+\(/g;

export const checkFilters = (context: ISearchContext, search: string) => {
    const filters = search.match(filterRegex) || [];
    const lexemes = context.filters.map(f => f.lexeme);

    // Find the bad filters and trim off the (
    return filters.filter(f => lexemes.indexOf(f) === -1).map(f => f.slice(0, -1));
}